export class SavedFormEvent {
    constructor(public isFormValid: boolean, public males?: number, public females?: number) {

    }
}
export class PageLoadedEvent {
}
export class ModalPopupMainPageEvent {
    constructor(public isOpen: boolean) {

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/app-events-types.model.ts